/* eslint-disable no-mixed-spaces-and-tabs */
/*=========================================================================================
  File Name: moduleContext.js
  Description: Auth Module
  ----------------------------------------------------------------------------------------
  Project: MISA MTAX WebApp
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/
import { theme } from '@/commons/enumeration';
const now = new Date();
import moment from 'moment';
import commonFn from '@/commons/commonFunction';
import accountApi from '@/apis/other/accountAPI';
import axios from 'axios';
import moduleDbOption from '@/stores/modules/dbOption';
import { ModuleDbOption } from '@/stores/moduleConst';
import contextApi from '@/apis/other/contextAPI';
import AuditingLogAPI from '@/apis/other/auditingLogAPI.js';

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state: {
    /**
     * Cờ đang xử lý
     */
    Loading: false,
    /**
     * Token đăng nhập
     */
    Token: null,
    /**
     * Thời điểm  token hết hạn
     */
    TokenExpired: null,
    /*
     * Trạng thái Collapse của left menu
     */
    LeftMenuCollapse: false,
    /**
     * Thông tin phân quyền
     * Key là subsystemCode, value sẽ là mảng string danh sách perrmission
     */
    Permission: [],
    /**
     * Thông tin thuê bao
     */
    License: {},
    /**
     * Thông tin tài khoản
     */
    User: {
      UserID: null,
      Email: null,
      FullName: null,
      Mobile: null,
      UserName: null
    },
    /**
     * Thông tin config
     */
    ConfigInfo: {
      CurrentDate: new Date(now.getFullYear(), now.getMonth(), now.getDay()),
      CurrentDateText: ''
    },
    /**
     * Định dạng số
     */
    NumberFormat: {
      GeneralDecimalSeparator: ',',
      GeneralGroupSeparator: '.',
      QuantityDecimalDigits: 1,
      AmountDecimalDigits: 0,
      AmountOCDecimalDigits: 2,
      UnitPriceDecimalDigits: 1,
      UnitPriceOCDecimalDigits: 1,
      ExchangRateDecimalDigits: 2,
      CoefficientDecimalDigits: 2,
      AllocationDecimalDigits: 2
    },
    OptionsData: {},
    /**
     * Ngôn ngữ hiện tại
     */
    Culture: 'vi',
    /**
     * Ngày hạch toán
     */
    PostedDate: new Date(),
    /**
     * Một số thông tin liên quan đến phiên làm việc hiện tại
     * Chỉ có 1 số thông tin ở đây, 1 số thông tin khi submit lên server sẽ lấy từ token: userid, databaseid, tenantid...
     */
    Context: {},

    // Theme config
    Theme: theme.light
  },
  mutations: {
    /**
     * Xét dữ liệu người dùng
     * @param {*} state
     * @param {object} userInfo dữ liệu người dùng
     * @author: BMThang(19/12/2022)
     */
    setUser: (state, userInfo) => {
      state.User = userInfo;
    },
    resetState(state) {
      let x = 1;
      //Object.assign(state, defaultConfigState);
    },
    updateConfig: function(state, payload) {
      let currentDate = moment(payload.CurrentDate).toDate();
      state.ConfigInfo = {
        ...state.ConfigInfo,
        ...payload,
        CurrentDate: currentDate,
        CurrentDateText: moment(currentDate).format('YYYY-MM-DD HH:mm:ss')
      };
    },
    updateCulture: function(state, payload) {
      state.Context.Culture = payload;
    },
    updateToken(state, payload) {
      // state.Context = payload.Context;
      state.TokenExpired = new Date().addSeconds(payload.TokenTimeout);
      state.Token = payload.Token;
      state.PostedDate = new Date();
    },

    updateContext(state, payload) {
      state.User = payload.User;
      state.Permission = payload.Permission || null;
    },

    updateLogout: async function(state, payload) {
      state.Token = null;
      state.Context = null;
      state.TokenExpired = null;
      state.User = null;
      state.Permission = null;

      //xóa all storage
      sessionStorage.clear();
      localStorage.clear();
    },

    updateLoading(state, payload) {
      state.Loading = payload;
    },
    updatePermission(state, payload) {
      state.Permission = payload;
    },
    /**
     * clear thông tin phiên đăng nhập
     */
    removeToken(state) {
      state.Token = null;
      state.Context = null;
      state.TokenExpired = null;
      state.User = null;
      state.Permission = null;
    },
    updateLeftMenuCollapse(state, payload) {
      state.LeftMenuCollapse = payload;
    },
    completeGetting(state) {
      let getting = {
        GettingStarted: true,
        SeenGetting: true
      };
      state.GettingStarted = getting;
      commonFn.setLocalStorage('GettingStarted', JSON.stringify(getting));
      window._getting = getting;
    },
    /**
     * Cập nhật postedDate
     * @param {*} state
     * @param {*} payload
     * tbngoc 28/07/2022
     */
    updatePostedDate(state, payload) {
      if (payload && payload.PostedDate) {
        state.PostedDate = payload.PostedDate;
      }
    },

    /**
     * Cập nhật theme
     * LMduc 08/11/2022
     */
    updateTheme(state, payload) {
      if (payload) {
        state.Theme = payload;
      }
    }
  },
  actions: {
    async getConfigInfo(context, payload) {
      try {
        context.commit('updateConfig', { CurrentDate: new Date() });
      } catch (ex) {
        commonFn.errorLogging('Lỗi lấy thông tin config:: ', ex);
      }
    },
    async setOrganizationUnit(context, payload) {
      context.commit('updateOrganizationUnit', payload);
    },

    /**
     * Đăng nhập
     */
    async loginCode(context, payload) {
      context.commit('updateLoading', true);
      var res = await accountApi.loginCode(payload);

      context.commit('updateLoading', false);

      if (res) {
        if (res.Token) {
          context.commit('updateToken', res);
        }

        return res;
      }
    },

    /**
     * Đăng nhập
     */
    async handleLogin(context, payload) {
      context.commit('updateLoading', true);
      var res = await accountApi.doLogin(payload);
      context.commit('updateLoading', false);
      if (res && res.Token) {
        await context.commit('updateToken', res);
      }
      return res;
    },

    /**
     * Xác thực 2 lớp
     */
    async handleVerifyTwoFactor(context, payload) {
      context.commit('updateLoading', true);
      var res = await accountApi.verifyTwoFactor(payload);
      context.commit('updateLoading', false);
      if (res && res.Token) {
        context.commit('updateToken', res);
      }
      return res;
    },

    /**
     * Lấy link để nhúng vào iframe form bật 2FA
     * DTQUOC: 23.07.2025
     */
    async getGeneratelinklogin(context, payload) {
      context.commit('updateLoading', true);
      var res = await accountApi.generatelinklogin(payload);
      context.commit('updateLoading', false);
      return res;
    },

    /**
     * Lấy context người dùng
     * @param {} context
     * @param {*} payload
     * @returns
     */
    async getContextData(context, payload) {
      context.commit('updateLoading', true);
      var res = await contextApi.getContext();
      context.commit('updateLoading', false);
      if (res) {
        context.commit('updateContext', res);
        return res;
      }
    },

    /**
     * Lấy context người dùng ứng với đơn vị cụ thể
     */
    async switchOrganization(context, payload) {
      context.commit('updateLoading', true);
      var res = await accountApi.switchOrganization(payload);
      context.commit('updateLoading', false);
      if (res) {
        context.commit('updateToken', res);
        return res;
      }
    },

    /**
     * Từ misaid sẽ gọi về callback api, trên api sẽ xử lý để chọn dữ liệu làm việc
     * Dựa theo phiên bản dữ liệu đó sẽ điều hướng về cụm api tương ứng và mã hóa thông tin user, database để truyền kèm
     * Client nhận dc token này sẽ gọi lên account api để đăng nhập
     */
    async loginCallback(context, payload) {
      context.commit('updateLoading', true);
      var res = await accountApi.loginCallback(payload);
      context.commit('updateLoading', false);
      if (res) {
        if (res.Token) {
          context.commit('updateToken', res);

          let dbOptions = moduleDbOption.state.dbOptions || {};
          if (Object.keys(dbOptions).length == 0) {
            context.dispatch(`${ModuleDbOption}/getDbOptions`, '', {
              root: true
            });
          }
        }

        return res;
      }
    },

    /**
     * Đăng xuất
     */
    async logout(context, payload) {
      context.commit('updateLoading', true);
      var res = await accountApi.logout(payload);

      context.commit('updateLoading', false);
      context.commit('updateLogout', res);

      let url = window._misaId.getUrl('logoutUrl');
      location.href = url;
    },

    /**
     * Lấy token
     */
    async getToken(context, payload) {
      context.commit('updateLoading', true);

      var res = await accountApi.getToken(payload);

      context.commit('updateLoading', false);

      if (res) {
        context.commit('updateToken', res);
        return res;
      }
    },
    /**
     * Lấy thông tin phân quyền
     */
    async getPermission(context, payload) {
      context.commit('updateLoading', true);
      //request
      var res = await accountApi.getPermission(payload);

      context.commit('updateLoading', false);

      if (res) {
        context.commit('updatePermission', res);
      }

      return res;
    },

    // eslint-disable-next-line no-mixed-spaces-and-tabs
    /**
     * Đăng xuất
     */
    async logoff(context) {
      context.commit('updateLoading', true);
      // lưu auditing log
      try {
        const me = this;
        let auditingLogs = [];
        var actionname = 'Logout Thành công';
        auditingLogs = [
          {
            eventtype: 'auditsecurity',
            companyid: context.getters.User.OrganizationID,
            companyname: context.getters.User.OrganizationName,
            userid: context.getters.User.UserID,
            username: context.getters.User.FullName,
            osname: navigator.userAgent,
            time: new Date(),
            securityeventtype: 2,
            securityactionid: 3,
            actionname: actionname,
            result: 1,
            description: `Người dùng ${
              context.getters.User.FullName
            } đã thực hiện ${actionname}`,
            databaseid: context.getters.User.TenantID,
            databasename: context.getters.User.TenantCode,
            roleid: context.getters.User.RoleType
          }
        ];
        AuditingLogAPI.Insert(auditingLogs);
      } catch (error) {
        console.error(error);
      }
      //remove token
      try {
        await accountApi.logoff().then(() => {
          //settimeout để tránh lỗi 1 số nơi đang dùng trực tiếp context
          setTimeout(() => {
            context.commit('updateLogout');
            location.href = '/login';
          }, 0);
        });
      } catch (error) {
        // Xử lý logout
        setTimeout(() => {
          context.commit('updateLogout');
          location.href = '/login';
        }, 0);
      }

      context.commit('updateLoading', false);
    },

    /**
     * remove token
     */
    removeToken(context) {
      //remove token
      context.commit('removeToken');
    },
    /*
     * Lấy trạng thái collapse của left menu 
     */
    getLeftMenuCollapse(context, payload) {
      context.commit('updateLeftMenuCollapse', payload);
    },
    /**
     * Cập nhật posted date
     * @param {*} context
     * @param {*} payload
     * tbngoc 28/07/2022
     */
    updatePostedDateContext(context, payload) {
      context.commit('updatePostedDate', payload);
    }
  },
  getters: {
    /**
     * Thông tin dữ liệu người dùng trong dashboard
     * @param {*} state
     * @returns
     */
    UserInfoDashBoard(state) {
      //Nếu là người dùng thuộc phòng ban có quyền xem toàn bộ dữ liệu đơn vị
      if (
        state.User.IsViewAllData &&
        state.User.OrganizationUnitID != state.User.OrganizationID
      ) {
        return {
          ...state.User,
          OrganizationUnitID: state.User.OrganizationID,
          OrganizationUnitName: state.User.OrganizationName,
          MISACode: state.User.MISACode.replace(/\/[^/]+\/$/, '/')
        };
      }
      return state.User;
    },
    ConfigInfo(state) {
      return state.ConfigInfo;
    },
    CurrentDate(state) {
      return state.ConfigInfo.CurrentDate;
    },
    Context(state) {
      return state.Context;
    },
    NumberFormat(state) {
      return state.NumberFormat;
    },
    Culture(state) {
      return state.Context.Culture;
    },
    OptionsData(state) {
      return state.OptionsData;
    },
    Token(state) {
      return state.Token;
    },
    Loading(state) {
      return state.Loading;
    },
    User(state) {
      return state.User;
    },
    Permission(state) {
      return state.Permission;
    },
    LeftMenuCollapse(state) {
      return state.LeftMenuCollapse;
    },
    PostedDate(state) {
      return state.PostedDate;
    }
  }
};
